import { z } from 'zod';
import { MAX_FILE_SIZE } from '@/config';

const _ACCEPTED_FILE_TYPES = ['application/zip'];

const _fileData = z
  .object({
    fieldname: z.string().default(''),
    originalname: z.string().default(''),
    encoding: z.string().default(''),
    mimetype: z.string().default(''),
    destination: z.string().default(''),
    filename: z.string().default(''),
    path: z.string().default(''),
    size: z.number().default(0),
  })
  .refine((file) => file !== null && file !== undefined, {
    message: 'file is required',
  });

export const bulkUploadFileSchema = z
  .file()
  .mime(['text/csv', 'application/csv', 'text/plain', 'application/json'], {
    message: 'Only .csv or .json format is supported.',
  })
  .max(MAX_FILE_SIZE, { message: `Max file size is 100MB.` })
  .refine((file) => file !== null && file !== undefined, {
    message: 'File is required',
  })
  .refine((file) => file?.size <= MAX_FILE_SIZE, {
    message: 'Max file size is 100MB.',
  });

export const fileSchema = z
  .file()
  .mime(['application/zip', 'application/x-zip-compressed'], {
    message: 'Only .zip format is supported.',
  })
  .max(MAX_FILE_SIZE, { message: `Max File size is ${MAX_FILE_SIZE}MB.` })
  .refine((file) => file !== null && file !== undefined, {
    message: 'File is required',
  })
  .refine((file) => file?.size <= MAX_FILE_SIZE, {
    message: `Max File size is ${MAX_FILE_SIZE}MB.`,
  });

export const forcedChecksSchema = z
  .object({
    question: z.boolean().default(false),
    topic: z.boolean().default(false),
    concept: z.boolean().default(false),
    station: z.boolean().default(false),
    ukmlaTopic: z.boolean().default(false),
    presentation: z.boolean().default(false),
    condition: z.boolean().default(false),
    theme: z.boolean().default(false),
  })
  .default({
    question: false,
    topic: false,
    concept: false,
    station: false,
    ukmlaTopic: false,
    presentation: false,
    condition: false,
    theme: false,
  });

export const forcedInsertsSchema = z
  .object({
    question: z.boolean().default(false),
    topic: z.boolean().default(false),
    concept: z.boolean().default(false),
    station: z.boolean().default(false),
    ukmlaTopic: z.boolean().default(false),
    presentation: z.boolean().default(false),
    condition: z.boolean().default(false),
    theme: z.boolean().default(false),
  })
  .default({
    question: false,
    topic: false,
    concept: false,
    station: false,
    ukmlaTopic: false,
    presentation: false,
    condition: false,
    theme: false,
  });

export const overWriteSchema = z.object({
  batchId: z.uuid({ message: 'Invalid Batch Id' }).nullable().optional(),
  resetLikes: z.boolean().nullable().default(false),
  resetProgress: z.boolean().nullable().default(false),
  resetVotes: z.boolean().nullable().default(false),
  picture: z.boolean().nullable().default(false),
});
